module.exports = require("glob");